import SmallSpinner from "./SmallSpinner";
import {Fragment} from "react";

function ValueOrSpinner({value, loading, prepend = '', append = ''}) {
	return value !== undefined ? <Fragment>{prepend}{value}{append}</Fragment>   : loading ? <SmallSpinner />: '';

}

export default ValueOrSpinner;